import { KeyInfoGrid } from "@/components/keyInfo";
import { useAppState } from "@/modules/app/useAppContext";
import { getInstanceName } from "@/helpers/utils";
import type { WarehouseDetails } from "@/pages/warehouse/types";

interface WarehouseKeyInfoProps {
  warehouseDetails: WarehouseDetails;
}

const WarehouseKeyInfo = ({ warehouseDetails }: WarehouseKeyInfoProps) => {
  const { datastores = [] } = useAppState();

  const formatAutoSuspend = (seconds?: number) => {
    if (!seconds) return "-";
    return `${Math.round(seconds)} sec`;
  };

  const formatClusters = () => {
    if (!warehouseDetails?.min_cluster_count || !warehouseDetails?.max_cluster_count) return "-";
    return `${warehouseDetails.min_cluster_count}/${warehouseDetails.max_cluster_count}`;
  };

  const items = [
    { label: "Scaling Policy", value: warehouseDetails.scaling_policy },
    { label: "Clusters (Min/Max)", value: formatClusters() },
    {
      label: "Auto-Resume",
      value: warehouseDetails.auto_resume === "true" ? "Enabled" : "Disabled",
    },
    { label: "Size", value: warehouseDetails.warehouse_size },
    {
      label: "Query Acceleration",
      value: warehouseDetails.enable_query_acceleration === "true" ? "Enabled" : "Disabled",
    },
    {
      label: "Query Acceleration Scale Factor",
      value: warehouseDetails.query_acceleration_max_scale_factor,
    },
    { label: "Warehouse Type", value: warehouseDetails.warehouse_type },
    {
      label: "Instance",
      value: getInstanceName(warehouseDetails.instance_id.toString(), datastores),
    },
    { label: "Auto suspend", value: formatAutoSuspend(warehouseDetails.auto_suspend) },
  ];

  return <KeyInfoGrid title="Key Information" items={items} />;
};

export default WarehouseKeyInfo;
